import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';

import Cookies from 'js-cookie';
import Logo from '../assets/999eKassa.png';
import { ACCESS_ID_COOKIE, ROLE_COOKIE } from '../constants';

import { ProfileDropdown } from './modules/ProfileDropdown/ProfileDropdown';
export default function TopBar() {
    let navigate = useNavigate();
    const { t } = useTranslation();
    const [auth, setAuth] = React.useState(false);

    React.useEffect(() => {
        if (Cookies.get('simpalsid.auth')) {
            setAuth(true);
        } else {
            setAuth(false);
            Cookies.remove(ACCESS_ID_COOKIE);
            Cookies.remove(ROLE_COOKIE);
        }
    }, []);

    // http://container--ereceipt.tag--124_resolve.port--9032.docker.simpals.com/

    function onClickShiftBtn() {
        // kostil - obhod top-bar
        if (auth) {
            Cookies.remove('simpalsid.auth', { domain: 'ekassa.id.md' });
            Cookies.remove('auth', { domain: 'ekassa.id.md' });
            window.TOPBAR?.logoutGlobal?.();
            navigate('/');
            // window.location = "https://simpalsid.com/user/logout?project_id=ce9647d5-7569-4ed5-84bc-cda1dc448946&redirect_url=https://ekassa.id.md"
        } else {
            window.location =
                'https://simpalsid.com/user/login?project_id=ce9647d5-7569-4ed5-84bc-cda1dc448946&lang=ru&redirect_url=https://ekassa.id.md';
        }

        // hack for containers
        // if (auth) {
        //   window.location = "http://container--topbar.docker.simpals.com/user/logout?project_id=ce9647d5-7569-4ed5-84bc-cda1dc448946&redirect_url=http://container--ereceipt.tag--124_resolve.port--9032.docker.simpals.com/"
        // } else {
        //   window.location = "http://container--topbar.docker.simpals.com/user/login?project_id=ce9647d5-7569-4ed5-84bc-cda1dc448946&lang=ru&redirect_url=http://container--ereceipt.tag--124_resolve.port--9032.docker.simpals.com/"
        // }
    }

    return (
        <Box sx={{ flexGrow: 1, position: 'absolute', width: '100%' }}>
            <AppBar
                // position="absolute"
                sx={{
                    marginTop: '35px',
                    backgroundColor: '#313238',
                    height: '76px',
                }}
            >
                <Toolbar>
                    <IconButton
                        size='large'
                        edge='start'
                        color='inherit'
                        aria-label='menu'
                        sx={{
                            mr: 2,
                            marginRight: '30px',
                            height: '76px',
                            width: '162px',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                        onClick={() => {
                            navigate('/');
                        }}
                    >
                        <img
                            src={Logo}
                            sx={{ height: '36px', top: '50%' }}
                            alt='logo'
                        />
                    </IconButton>
                    <Typography
                        variant='h6'
                        component='div'
                        sx={{ flexGrow: 1 }}
                    ></Typography>

                    <Button
                        variant='outlined'
                        sx={{
                            color: '#acb44e',
                            borderColor: '#acb44e',
                            marginRight: 2,
                        }}
                        onClick={() => {
                            onClickShiftBtn();
                        }}
                    >
                        <b>
                            {auth
                                ? t('shift_closing_btn')
                                : t('shift_opening_btn')}
                        </b>
                    </Button>
                    {auth && <ProfileDropdown />}
                </Toolbar>
            </AppBar>
        </Box>
    );
}
